module.exports = __webpack_public_path__ + "static/img/moving-to-amsterdam.4b06a42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timeline/moving-to-amsterdam.jpg
// module id = 221
// module chunks = 0